export const GROUP_REPORT = "GROUP_REPORT"
export const GROUP_REPORT_SUCCESSFUL = "GROUP_REPORT_SUCCESSFUL"
export const GROUP_REPORT_FAILED = "GROUP_REPORT_FAILED"
export const GROUP_FETCH = "GROUP_REPORT_FAGROUP_FETCHILED"
export const GROUP_FETCH_SUCCESSFUL = "GROUP_FETCH_SUCCESSFUL"
export const GROUP_FETCH_FAILED = "GROUP_FETCH_FAILED"





